<div class="app-titulo-pagina">
    <span>Transferência {{ this.mainService.cartaoService.cartao.produto.nome }}</span>
</div>
<div class="container">
    <article *ngIf="!processando"
             class= "col-xs-12 col-md-8 col-md-offset-2 app-msg-transf">
        <h4>
            Com o cartão {{ this.mainService.cartaoService.cartao.produto.nome }} você consegue converter seus pontos, transformando os em reais para usar em qualquer estabelecimento que aceite a bandeira {{ this.mainService.cartaoService.cartao.produto.bandeira }}. 
        </h4>
    </article>

    <form *ngIf="!processando" 
          class="col-xs-12 col-md-8 col-md-offset-2"
          ngNativeValidate>
        <div class="panel panel-default">
            <div class="panel-body">
                <div *ngIf="!avisoTransf" 
                     class="col-xs-12">
                    <strong>
                        Ao transferir para seu cartão {{ this.mainService.cartaoService.cartao.produto.nome }} seus pontos serão migrados de forma permanente. 
                        Seu saldo transferido ficara disponível <strong>apenas</strong> <span *ngIf="this.mainService.cartaoService.cartao.produto.saque">para *saque e</span> em postos credenciados {{ this.mainService.cartaoService.cartao.produto.bandeira }}. </strong>
                    <div class="checkbox">
                        <label><input type="checkbox" name="concordo" [(ngModel)]="concordo">li e desejo continuar</label>
                    </div>
                    <div class="col-xs-12 text-center" style="margin-top: 25px;">
                        <a class="btn btn-danger-v2" (click)="mainService.loginService.changeRoute('transferencias')">
                            Cancelar
                        </a>
                        <button class="btn app-btn-best-v2"
                                *ngIf="concordo"
                                (click)="liberaTransferencia()">
                            Continuar</button>
                    </div>
                </div>
                <div *ngIf="avisoTransf"
                     class="col-xs-12">
                    <div class="col-xs-12">
                        <label>Saldo Atual em Reais</label><br/>
                        <label class="app-texto-cor-azul">{{ saldoService.saldo.saldoMoeda | currency:'BRL':'symbol':'1.2-2':'pt' }}</label>
                        <hr>

                    </div>
                    <div class="col-xs-12">
                        <label for="tarifa">Valor da tarifa em Pontos</label>
                        <input value="{{ taxaTransferencia }}"  type="text" id="tarifa" class="form-control input-sm" readonly>
                    </div>
                    <div class="col-xs-12">
                        <label for="valorMoeda">Valor liquido a ser transferido em Moeda</label>
                        <div class="input-group">
                            <span class="input-group-addon" id="basic-addon2">R$</span>
                            <input id="valorMoeda"
                                   type="text"
                                   maxlength="8"
                                   [(ngModel)]="valorMoeda"
                                   name="valorMoeda"
                                   (ngModelChange)="calculaValorPontos()"
                                   class="form-control input-sm"
                                   uiMoeda 
                                   required>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <label for="valor">Valor total do debito em pontos</label>
                        <input type="text" id="valor" class="form-control input-sm" 
                                name="debitoPontos"
                               [(ngModel)]=" debitoPontos " readonly>

                    </div>
                    <div class="col-xs-12 form-group">
                        <label for="epwd">Senha eletrônica </label>
                        <input type="password"
                               id="epwd"
                               class="form-control input-sm"
                               [(ngModel)]="epwd"
                               name="epwd"
                               required>
                    </div>
                </div>

                <div *ngIf="avisoTransf" 
                     class="col-xs-12 text-left">
                    <div class="alert alert-warning" role="alert">
                        <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Limite diário para transferência {{ limiteTransferencia | currency:'BRL':'symbol':'1.2-2':'pt' }}</p>

                    </div>
                </div>

            </div>
            <div *ngIf="avisoTransf" 
                 class="col-xs-12 text-center"
                 style="margin-top: 2em;">
                <a id="btn-voltar" class="btn btn-danger-v2" (click)="mainService.loginService.changeRoute('transferencias')">
                    Voltar
                </a>
                <button id="confirmar-transferencia" type="button" class="btn btn-success-v2" *ngIf="epwd >= 1" (click)="save()">
                    Confirmar
                </button>
            </div>
        </div>    
    </form>
    <div *ngIf="processando"
         class="text-center">
        <i class="fa fa-spinner fa-pulse fa-4x"></i>
    </div>
</div>    



// WEBPACK FOOTER //
// ./src/app/transferencia/bandeirado/bandeirado.component.html